<script lang="ts">
  import '$lib/styles/app.css';
  import type { Snippet } from 'svelte';

  let { children }: { children: Snippet } = $props();
</script>

<svelte:head>
  <title>Publicatie Portaal — De Vries Web</title>
</svelte:head>

{@render children()}
